
import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { requestInfoFragment } from "./fragments/request-info.fragment";
import { IRequestInfo } from "@collections/request-info/interfaces";
import { pageInfoFragment } from '../common/fragments/page-info.fragment';
import { IPage } from '@collections/common/interfaces';

export interface IRequestByCompanyIdResponse {
    requestInfoByCompanyId: IPage<IRequestInfo>
}

@Injectable()
export class RequestInfoByCompanyIdGQL extends Query<IRequestByCompanyIdResponse>{
    document = gql`
    query getRequestsInfoByCompanyId($first: Int, $recipientCompany: ObjectId!, $lang: String!){
        requestInfoByCompanyId(first:$first, recipientCompany: $recipientCompany){
            totalCount
            edges{
                cursor
                node {
                    ...requestInfo
                    email
                    sender(lang: $lang){
                          username
                    }
                    recipientCompany(lang: $lang){
                        _id
                        fullName
                        logo
                        primaryPath
                        slug
                        accountType
                    }
                    recipientNews {
                        _id
                        title
                        image
                        slug
                        canonicalUrl
                    }
                    recipientProduct(lang: $lang) {
                        _id
                        name
                        images
                        slug
                    }
                }
            }
            pageInfo {
                ...pageInfo
            }
        }
    }
    ${requestInfoFragment}
    ${pageInfoFragment}
    `;
}
